import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useAutoSpinner } from "~/shared/hooks/use-global-spinner.ts";
import { useIsAuthenticated } from "~/shared/utils/use-is-authenticated.tsx";

import { SendDocsScreen } from "../../../quote/components/shipment-details/components/tender-modal/components/send-docs-screen/send-docs-screen.tsx";
import { useBulkTenderDocumentsEmailComposer } from "../../hooks/use-bulk-tender-document-email.ts";
import type { BulkTenderDocumentsEmailResponse } from "../../schemas/bulk-tender-document-email-schema.ts";
import type { BulkTenderDocumentFormData } from "../../schemas/bulk-tender-document-schema.ts";

type BulkTenderSendModalProps = {
	quoteIds: number[];
	formData: BulkTenderDocumentFormData;
	onClose: () => void;
	onSent: (response: BulkTenderDocumentsEmailResponse) => void;
};

export const BulkTenderSendModal = ({
	quoteIds,
	formData,
	onClose,
	onSent,
}: BulkTenderSendModalProps) => {
	const { isInternal } = useDeploymentType();
	const { email } = useIsAuthenticated();
	const composer = useBulkTenderDocumentsEmailComposer({
		email,
		formData,
		isInternal,
		onSent,
		onError: () => undefined,
		quoteIds,
	});
	useAutoSpinner(composer.isLoading);

	return (
		<TraxModal onClose={onClose}>
			<SendDocsScreen
				formData={null}
				isLoading={composer.isLoading}
				onBackClick={onClose}
				onDownload={undefined}
				onFormDataChange={() => undefined}
				onView={undefined}
				readOnlyContent={!isInternal}
				sendDocsHook={composer}
				trackingLinkMode={isInternal ? "inline" : "per-shipment"}
			/>
		</TraxModal>
	);
};
